import { render, staticRenderFns } from "./UploadCover.vue?vue&type=template&id=c591ef06&"
import script from "./UploadCover.vue?vue&type=script&lang=js&"
export * from "./UploadCover.vue?vue&type=script&lang=js&"
import style0 from "./UploadCover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c591ef06')) {
      api.createRecord('c591ef06', component.options)
    } else {
      api.reload('c591ef06', component.options)
    }
    module.hot.accept("./UploadCover.vue?vue&type=template&id=c591ef06&", function () {
      api.rerender('c591ef06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/UploadCover.vue"
export default component.exports